import { ReactNode, useState } from 'react'
import { Menu } from '../../components/SideBar/Menu'
import { Top } from '../../components/Top/Top'
import { ChatSuporte } from '../../components/ChatSuporte/ChatSuporte'
import { Container, Wrapper } from './LayoutPage.style'

type LayoutPageProps = {
  children: ReactNode
}

export function LayoutPage({ children }: LayoutPageProps) {
  const [isBigMenu, setIsBigMenu] = useState(true)

  const bigMenu = () => setIsBigMenu(!isBigMenu)

  return (
    <div>
      <Container>
        <Menu isBigMenu={isBigMenu} />
        <Top bigMenu={bigMenu} isBigMenu={isBigMenu} />
        <Wrapper isBigMenu={isBigMenu}>{children}</Wrapper>
        {/* Não renderiza nada: o widget do Movidesk é montado no body pelo script do fornecedor.
            Fica aqui por ser o ponto comum das telas autenticadas — o próprio componente decide
            se aparece (só na visualização do Cartivia, e só com o chat ligado no tenant). */}
        <ChatSuporte />
      </Container>
    </div>
  )
}
